import React, { useEffect, useState } from "react";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { default as Select, components }  from "react-select";
import $ from "jquery";
import * as ReactDOM from 'react-dom';
import "datatables.net";
import { useNavigate,useHistory } from "react-router-dom";
import axios from 'axios';
import {getFilenameFromURL,getUsername,replaceSpacesWithUnderscores,capitalizeFirstLetterOfEachWord} from "../../utils/common_functions"
import {API_SERVER_URL} from "../../utils/config_ip_details";
import {API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE,CONTRACT_POLLING_MAX_COUNT,CONTRACT_STATUS_CHECK_POLLING_DURATION} from "../../utils/config_mapping"
import {apiCall} from "../../utils/server_utils"
import CommonIcon from '../common/customicon';
import PageLoader from '../common/pageloader';
import ProcessLoader from '../common/processloader';
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.css";
import {trackError} from "../../utils/error_tracker"
import {OVERVIEW_META_DATA} from "../../utils/config_mapping";
import Message from "../common/message";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";



export const GenericDocument = () => {
  
  let pollingInterval = null; // Store the interval for polling
  let pollingCount = 0; // Track the number of polling attempts

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const [adddocumentmodal, setAddDocumentModal] = useState(false);
  const handleClose = () => setAddDocumentModal(false);
  const handleShow = () => setAddDocumentModal(true);

  const [deletedocumentmodal, setDeleteDocumentModal] = useState(false);
  const handleDeleteClose = () => setDeleteDocumentModal(false);
  const handleDeleteShow = () => {setDeleteDocumentModal(true); setIsDeleting(false);}
  const [isDeleting, setIsDeleting] = useState(false); // Prevent multiple triggers


  const [loading, setLoading] = useState(true); // State to track loading
  const [data, setData] = useState([]); // State to hold API data
  const [taxonomyOptions, setTaxonomyOptions] = useState([]); // Licensor dropdown options
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]); // Document Type dropdown options
  const [masterDocumentOptions, setMasterDocumentOptions] = useState([]); // Document Type dropdown options
  const statusoptions =[{label:"Error",value:"Error"},{label:"Running",value:"Running"},{label:"Success",value:"Success"}]
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({
  filterdocumentType: null,
  filtertaxonomy: null,
  filterexpiryDate: "",
  filterstatus: null,
  filterTextSearch: ""
});
const [expandedRows, setExpandedRows] = useState({});
const [uploadProgress, setUploadProgress] = useState({});
const [uploadQueue, setUploadQueue] = useState([]);
const [isUploading, setIsUploading] = useState(false);


//#-- Tab
const [activeTab, setActiveTab] = useState('List View');  // State for active tab
const handleTabChange = (tabId) => {
  setActiveTab(tabId);
  if(tabId === "Folder View"){
    setFilters({
      filterdocumentType: null,
      filtertaxonomy: null,
      filterexpiryDate: "",
      filterstatus: null,
      filterTextSearch: ""
    })
  }
};
//#--


  const initialState = {
    taxonomy: null,
    documentType: null,
    masterFile: "",
    documentFile: null,
    contractNo:"",
  }
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Fetch Licensor and Document Type data
  useEffect(() => {
      const fetchDropdownData = async () => {
        try {
          let apiUrl = API_SERVER_URL+ 'taxonomy/'
          let method = "GET"
          const result = await apiCall(method,apiUrl);
          if(result!==undefined){
          if (result.code === API_SUCCESS_RESPONSE_CODE && Array.isArray(result.data)) {
          
          // Sort the taxonomy list by taxonomyName in ascending order
          const sortedTaxonomyData = [...result.data].sort((a, b) =>
            a.taxonomyName.localeCompare(b.taxonomyName)
          );
            
            setTaxonomyOptions([
              ...sortedTaxonomyData.map((item, i) => ({
                value: item._id,
                label: item.taxonomyName,
              })),
            ]);
          } else {
            trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
          }
          }

         //#--  Master Document List 
         try {
          let apiMasterDocumentUrl = API_SERVER_URL+ 'documents/master/'
          let methodMasterDocument = "GET"
          let resultMasterDocuemnts = await apiCall(methodMasterDocument,apiMasterDocumentUrl);
          if(resultMasterDocuemnts!==undefined){
          if (resultMasterDocuemnts.code === API_SUCCESS_RESPONSE_CODE) {
            setMasterDocumentOptions([
              // { value: "", label: "Select a Taxonomy" }, // Add an empty option
              ...resultMasterDocuemnts.data.map((item, i) => ({
                value: item._id,
                label: getFilenameFromURL(item.FilePath),
              })),
            ]);
          } else {
             trackError("The API response is invalid:<br/>URL:"+apiMasterDocumentUrl+"<br/>Method:"+methodMasterDocument+"<br>", JSON.stringify(resultMasterDocuemnts))
          }
          }
        } catch (error) {
          console.error("Error fetching dropdown data:", error);
        }
        //#--

           let apiDocumentTypeUrl = API_SERVER_URL+ 'documents/types/'
           let methodDocumentType = "GET"
           let resultDocumentType = await apiCall(methodDocumentType,apiDocumentTypeUrl);
          if(resultDocumentType!==undefined){
          if (resultDocumentType.code === API_SUCCESS_RESPONSE_CODE && Array.isArray(result.data))  {

            // Sort the document type list if it's not empty
            const sortedDocumentType = [...resultDocumentType.data].sort((a, b) =>
              a.documentTypeName.localeCompare(b.documentTypeName)
            );

            setDocumentTypeOptions([
              ...sortedDocumentType.map((item, i) => ({
                value: item.documentTypeName,
                label: item.documentTypeName,
              })),
            ]);
            
          } else {
            trackError("The API response is invalid:<br/>URL:"+apiDocumentTypeUrl+"<br/>Method:"+methodDocumentType+"<br>", JSON.stringify(resultDocumentType))
          }
          }
        } catch (error) {
          console.error("Error fetching dropdown data:", error);
        }
      };
      fetchDropdownData();
    }, []);

    const handleView = (id,name) => {
       const fileName = getFilenameFromURL(name);
       navigate("/document-details/"+id+"/"+fileName+"/view")
        console.log("View button clicked for ID:", id);
    };


    const handleAskgenie = (id,name) => {
      const fileName = getFilenameFromURL(name);
      navigate("/document-details/"+id+"/"+fileName+"/askgenie")
       console.log("View button clicked for ID:", id);
   };

    const handleDelete = async (event) => {
      const dataId = event.target.getAttribute('data-id');
      if(dataId){

        if (isDeleting) return; // Prevent multiple clicks
        setIsDeleting(true);

        
        let apiUrl = API_SERVER_URL+ 'contracts/'+dataId+'/delete/'
        let method = "POST"
        try {
            const result = await apiCall(method,apiUrl);
            if(result!==undefined){
            if (result.code === API_SUCCESS_RESPONSE_CODE) {
              handleDeleteClose()
              setIsDeleting(false);
              fetchData();
            } else {
              trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
            }
            }
        } catch (error) {
          console.error("Error refreshing token:", error);
        }
      }
    };

    const fetchData = async () => {
      $(".page_pro_load").hide();
      setLoading(true); // start loading spinner
      try {
        const result = await apiCall("GET", `${API_SERVER_URL}contracts/`);
        if (result.code === API_SUCCESS_RESPONSE_CODE) {

        // Extract _id values where StatusCode is "Running"
        const ids = result.data
        .filter(item => item.status && item.status.StatusCode === "Running")
        .map(item => item._id);
      
        // If there are IDs with StatusCode "Running", start polling for status
        if (ids.length > 0) {
          const id_comma_separated = ids.join(',');
          pollForStatus(id_comma_separated);
        }
          setData(result.data);
          setFilteredData(result.data); // Set initial data for filtering
         
        } else {
          console.warn("Unexpected response status:", result.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
         setLoading(false); // Stop loading spinner
     }
    };
 useEffect(() => {
      fetchData();
 }, []); // Empty dependency array ensures this runs only once
  

 


 const pollForStatus = (id_comma_separated) => {
  // Clear any previous interval to prevent multiple polling instances
  if (pollingInterval) {
    clearInterval(pollingInterval);
  }
  pollingCount = 0; // Reset polling count before starting
  // Start polling every 30 seconds
  pollingInterval = setInterval(async () => {
    if (pollingCount >= CONTRACT_POLLING_MAX_COUNT) {
      console.warn("Max polling attempts reached. Stopping polling.");
      clearInterval(pollingInterval);
      return;
    }

    try {
      const result_status_check = await apiCall("GET", `${API_SERVER_URL}contracts/status/?id_list=` + id_comma_separated);

      if (result_status_check.code === API_SUCCESS_RESPONSE_CODE) {
        // Check if any of the statuses is "Success"
        const successFound = result_status_check.data.some(item => item.status.StatusCode.toLowerCase() === "success");
        if (successFound) {
          console.log("Success found! Fetching data...");
          clearInterval(pollingInterval); // Stop polling once success is found
          await fetchData(); // Call fetchData when "Success" is found
        }
      } else {
        console.warn("Unexpected response status in status check:", result_status_check.status);
      }
    } catch (error) {
      console.error("Error during status check:", error);
    }

    pollingCount++; // Increment polling count after each attempt
  }, CONTRACT_STATUS_CHECK_POLLING_DURATION); // Poll every 30 seconds
};



  useEffect(() => {

    if(activeTab==="List View"){
      setTimeout(() => {
        if ($.fn.DataTable.isDataTable("#contract_grid")) {
          $("#contract_grid").DataTable().destroy(); // Destroy existing DataTable
          $("#contract_grid").empty(); // Clear previous data to prevent duplication
        }
      if (filteredData.length > -1) {
        const tablecontract_grid = $("#contract_grid").DataTable({
          scrollCollapse: true,
        // "dom": '<"top"f>rt<"bottom"l p><"clear">',  // Length menu (l) before pagination (p)
          //   dom: '<"float-left"B><"float-right"f>rt<"row"<"col-sm-4"l><"col-sm-4"i><"col-sm-4"p>>',
          scrollX: true,
          pageLength: 25, // Set default number of records per page
          scrollY:$(window).height()-($("#table_height").height()+180),
          data: filteredData,
          destroy: true, // Ensure the previous table is destroyed
          order: [],  // This disables default sorting on any column
          "columnDefs": [
          { "className": "text-center", "targets": -1 }, // Last column center-aligned
          { "className": "text-left", "targets": "_all" } // All other columns left-aligned
        ],
          columns: [
          
            {
              data: "FilePath",
              title: "Document Name",
              width: "200px",
              render: function (data, type, row) {
                return `<a href="javascript:void(0);" class="view-btn" data-id="${row._id}" data-name="${row.FilePath}" data-status="${row.status.StatusCode}">
                          ${getFilenameFromURL(data)} <i class="datatable-open-document-icon"></i
                        </a>`;
              }
            },
            //{ data: "_id", title: "Contract ID", width: "40px"},
            {
              data: "status",
              title: "Status",
              width: "40px",
              render: function (data, type, row) {
                let status = data.StatusCode;
                // Check if data.StatusCode is undefined or null before calling toLowerCase
                if (status !== undefined && status !== null) {
                  status = status.toLowerCase();
                } else {
                  // Handle undefined or null case if needed
                  status = 'unknown'; // Or any default value
                }
                //return status;
                if (status === "success") {
                  return `<span className="badge bg-success">Success</span>`;
                } else if (status === "error") {
                  return `<span className="badge bg-danger">Failed</span>`;
                } else {
                  return `<span className="badge bg-warning">Running</span>`;
                }
              }
            },
            { data: "documentType", title: "Document Type", width: "10px" },
            { data: "masterDocId", title: "Master Document", width: "10px", render: function (data, type, row) {
              return row["masterDocId"] === "" ? "" : row["masterDocFileName"];
            }
          },
            { data: "importdate", title: "Imported Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", width: "150px",className: "text-left", // Add this to left-align the date column
              render: function (data, type, row) {
                return " "+row["importdate"];
              }
            },
            { data: "importedby", title: "Imported By", width: "40px" },
            {
              title: "Actions",
              orderable: false, // Disable sorting for this column
              data: null,
              width: "60px", 
              createdCell: function (td, cellData, rowData, row, col) {
                // Clear the default HTML and replace it with React-rendered content
                ReactDOM.render(
                  <>
                    <OverlayTrigger
                      placement="top"
                      trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                      overlay={<Tooltip id="view-top">View</Tooltip>}
                    >
                      <a href="javascript:void(0);" className="view-btn" data-id={rowData._id} data-name={rowData.FilePath} data-status={rowData.status.StatusCode}>
                        <i className="datatable-edit-icon"></i>
                      </a>
                    </OverlayTrigger>
                    &nbsp;
                    <OverlayTrigger
                      trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                      placement="top"
                      overlay={<Tooltip id="delte-top">Delete</Tooltip>}
                    >
                    <a href="javascript:void(0);" className="delete-btn" data-bs-toggle="modal"
                      data-bs-target="#confirmationModal" data-id={rowData._id} data-name={rowData.FilePath}>
                      <i className="datatable-delete-icon"></i>
                    </a></OverlayTrigger>
                    &nbsp;
                    <OverlayTrigger
                      trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                      placement="top"
                      overlay={<Tooltip id="askgenie-top">Ask Genie</Tooltip>}
                    >
                    <a href="javascript:void(0);" className="askgenie-btn" data-id={rowData._id} data-name={rowData.FilePath} data-status={rowData.status.StatusCode}>
                      <i className="datatable-askgenie-icon"></i>
                    </a></OverlayTrigger>
                  </>,
                  td // Render the content directly into the table cell
                );
              }
            },
          ],
          paging: true,
          searching: false,
          ordering: true,
          responsive: true,
          fixedHeader: true,
          language: {
            emptyTable: "No data found matching the filters",  // Custom message for no data
          },
        });

        $('.menu-icon').on('click', function() {
          // Adjust DataTable columns and redraw when the sidebar menu is toggled
          setTimeout(function() {
            tablecontract_grid.columns.adjust().draw();
          }, 100); // Adjust the delay time based on your sidebar transition duration
        });

        // $('.menu-icon').on('click', function() {
        //   // Adjust DataTable columns and redraw when the sidebar menu is toggled
        //   setTimeout(function() {
        //     table.columns.adjust().draw();
        //   }, 100); // Adjust the delay time based on your sidebar transition duration
        // });

        // Attach click handlers again for view, delete, and askgenie buttons
        $("#contract_grid").on("click", ".view-btn", function () {
          const id = $(this).data("id");
          const name = $(this).data("name");
          const status = $(this).data("status");
          if(status==="Success" || status==="success"){
            handleView(id, name);
          }else{
            const targetElement = document.getElementById("app_err");
  if (targetElement) {
                ReactDOM.unmountComponentAtNode(targetElement);
  }
  ReactDOM.render(<Message type='info' message="Please wait while the document is being processed." />, targetElement);

          }
        });

        $("#contract_grid").on("click", ".delete-btn", function () {

          handleDeleteShow()
          const id = $(this).data("id");
          const name = getFilenameFromURL($(this).data("name"));
          setTimeout(function() {
            $("#btn_delete").attr("data-id", id);
            $("#document_name").html(name);
          }, 200);
          
              });
    
        $("#contract_grid").on("click", ".askgenie-btn", function () {
          const id = $(this).data("id");
          const name = $(this).data("name");
          const status = $(this).data("status");
          if(status==="Success" || status==="success"){
            handleAskgenie(id, name);
          }
          else{
            const targetElement = document.getElementById("app_err");
  if (targetElement) {
                ReactDOM.unmountComponentAtNode(targetElement);
  }
  ReactDOM.render(<Message type='info' message="Please wait while the document is being processed." />, targetElement);

          }
        });
        return () => {
          tablecontract_grid.destroy(); // Clean up DataTable instance
        };
      }
      }, 10); // 3 seconds delay

    }else {
      if (filteredData.length > -1) {
         setTimeout(() => {

          if ($.fn.DataTable.isDataTable("#contract_grid_expand")) {
            $("#contract_grid_expand").DataTable().destroy();
            $("#contract_grid_expand").empty();
          }



          const tablecontract_grid_expand = $("#contract_grid_expand").DataTable({
            data: flattenData(filteredData),
            scrollCollapse: true,
            // "dom": '<"top"f>rt<"bottom"l p><"clear">',  // Length menu (l) before pagination (p)
            //   dom: '<"float-left"B><"float-right"f>rt<"row"<"col-sm-4"l><"col-sm-4"i><"col-sm-4"p>>',
            scrollX: true,
            pageLength: 25, // Set default number of records per page
            scrollY:$(window).height()-($("#table_height").height()+180),
            destroy: true, // Ensure the previous table is destroyed
            order: [],  // This disables default sorting on any column
            columns: [
              // {
              //   data: "FilePath",
              //   title: "Expand",
              //   render: function (data, type, row) {
              //     return `<button class="toggle-btn" data-id="${row._id}">➕</button>`;
              //   },
              // },
              {
                
                data: "FilePath",
                title: "Document Name",
                render: function (data, type, row) {


                  // return `<a href="javascript:void(0);" class="view-btn" data-id="${row._id}" data-name="${row.FilePath}" data-status="${row.status.StatusCode}">
                  //         ${getFilenameFromURL(data)} <i class="datatable-open-document-icon"></i
                  //       </a>`;


                    let indent = row.level > 0 ? "&nbsp;&nbsp;&nbsp;&nbsp;" : ""; // Indentation for children
                    let toggleIcon = row.children.length > 0
                        ? `<a href="javascript:void()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg></a>`
                        : `<a title="No Amendment Found" style="cursor: not-allowed;" href="javascript:void()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg></a>`; // Expand icon for parent rows
            
                    return `
                        ${indent}
                        <span class="toggle-btn" data-id="${row._id}">${toggleIcon}</span>
                        <a href="javascript:void(0);" href="${data}" class="view-btn" data-id="${row._id}" data-name="${row.FilePath}" data-status="${row.status.StatusCode}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>${getFilenameFromURL(data)}</a>
                    `;
                },
            },
            {
              data: "status",
              title: "Status",
              width: "40px",
              render: function (data, type, row) {
                let status = data.StatusCode;
                // Check if data.StatusCode is undefined or null before calling toLowerCase
                if (status !== undefined && status !== null) {
                  status = status.toLowerCase();
                } else {
                  // Handle undefined or null case if needed
                  status = 'unknown'; // Or any default value
                }
                //return status;
                if (status === "success") {
                  return `<span className="badge bg-success">Success</span>`;
                } else if (status === "error") {
                  return `<span className="badge bg-danger">Failed</span>`;
                } else {
                  return `<span className="badge bg-warning">Running</span>`;
                }
              }
            },
              { data: "documentType", title: "Document Type" },
              { data: "importdate", title: "Imported Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", width: "150px",className: "text-left", // Add this to left-align the date column
                render: function (data, type, row) {
                  return " "+row["importdate"];
                }
              },
              { data: "importedby", title: "Imported By" },
              {
                title: "Actions",
                orderable: false, // Disable sorting for this column
                data: null,
                width: "60px", 
                createdCell: function (td, cellData, rowData, row, col) {
                  // Clear the default HTML and replace it with React-rendered content
                  ReactDOM.render(
                    <>
                      <OverlayTrigger
                        placement="top"
                        trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                        overlay={<Tooltip id="view-top">View</Tooltip>}
                      >
                        <a href="javascript:void(0);" className="view-btn" data-id={rowData._id} data-name={rowData.FilePath} data-status={rowData.status.StatusCode}>
                          <i className="datatable-edit-icon"></i>
                        </a>
                      </OverlayTrigger>
                      &nbsp;
                      <OverlayTrigger
                        trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                        placement="top"
                        overlay={<Tooltip id="delte-top">Delete</Tooltip>}
                      >
                      <a href="javascript:void(0);" className="delete-btn" data-bs-toggle="modal"
                        data-bs-target="#confirmationModal" data-id={rowData._id} data-name={rowData.FilePath}>
                        <i className="datatable-delete-icon"></i>
                      </a></OverlayTrigger>
                      &nbsp;
                      <OverlayTrigger
                        trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                        placement="top"
                        overlay={<Tooltip id="askgenie-top">Ask Genie</Tooltip>}
                      >
                      <a href="javascript:void(0);" className="askgenie-btn" data-id={rowData._id} data-name={rowData.FilePath} data-status={rowData.status.StatusCode}>
                        <i className="datatable-askgenie-icon"></i>
                      </a></OverlayTrigger>
                    </>,
                    td // Render the content directly into the table cell
                  );
                }
              },
            ],
            paging: true,
            searching: false,
            ordering: true,
            lengthChange: false, // Hides the "Show entries" dropdown
            responsive: true,
            fixedHeader: true,
            language: {
              emptyTable: "No data found matching the filters",  // Custom message for no data
            }
          });

          
          $('.menu-icon').on('click', function() {
            // Adjust DataTable columns and redraw when the sidebar menu is toggled
            setTimeout(function() {
              tablecontract_grid_expand.columns.adjust().draw();
            }, 100); // Adjust the delay time based on your sidebar transition duration
          });


          // Attach click handlers again for view, delete, and askgenie buttons
        $("#contract_grid_expand").on("click", ".view-btn", function () {
          const id = $(this).data("id");
          const name = $(this).data("name");
          const status = $(this).data("status");
          if(status==="Success" || status==="success"){
            handleView(id, name);
          }else{
            const targetElement = document.getElementById("app_err");
  if (targetElement) {
                ReactDOM.unmountComponentAtNode(targetElement);
  }
  ReactDOM.render(<Message type='info' message="Please wait while the document is being processed." />, targetElement);

          }
        });



        $("#contract_grid_expand").on("click", ".delete-btn", function () {

          handleDeleteShow()
          const id = $(this).data("id");
          const name = getFilenameFromURL($(this).data("name"));
          setTimeout(function() {
            $("#btn_delete").attr("data-id", id);
            $("#document_name").html(name);
          }, 200);
          
              });
    
        $("#contract_grid_expand").on("click", ".askgenie-btn", function () {
          const id = $(this).data("id");
          const name = $(this).data("name");
          const status = $(this).data("status");
          if(status==="Success" || status==="success"){
            handleAskgenie(id, name);
          }
          else{
            const targetElement = document.getElementById("app_err");
  if (targetElement) {
                ReactDOM.unmountComponentAtNode(targetElement);
  }
  ReactDOM.render(<Message type='info' message="Please wait while the document is being processed." />, targetElement);

          }
        });


          function flattenData(data) {
          
            const structuredData = {}; // Store documents by _id
            const rootDocuments = []; // Store top-level documents
  
            // Step 1: Build a lookup dictionary
            data.forEach((doc) => {
              structuredData[doc._id] = { ...doc, children: [] };
            });
          
            // Step 2: Link children to parents
            data.forEach((doc) => {
              if (doc.masterDocId && structuredData[doc.masterDocId]) {
                structuredData[doc.masterDocId].children.push(structuredData[doc._id]);
              } else {
                rootDocuments.push(structuredData[doc._id]); // Top-level documents
              }
            });
          
            // Step 3: Flatten while preserving hierarchy
            const result = [];
            function addWithChildren(doc, level = 0) {
              result.push({ ...doc, level }); // Add the document itself
              doc.children.forEach((child) => addWithChildren(child, level + 1)); // Recursively add children
            }
            rootDocuments.forEach((doc) => addWithChildren(doc));
            return rootDocuments;
          }

            // Expand/Collapse Logic

            
            
    $("#contract_grid_expand tbody").on("click", ".toggle-btn1", function () {
      const tr = $(this).closest("tr");
      const row = tablecontract_grid_expand.row(tr);
      const docId = $(this).attr("data-id");
      const statuscode =  $(this).attr("status");


      if (row.child.isShown()) {
        row.child.hide();
        $(this).html(`
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
        `);
      } else {

        let arrWidth = []
        let arrHeight = []

        $("#contract_grid_expand tbody tr:nth-child(1) td").each(function(index) {
          arrWidth.push($(this).width()+`px`)
          arrHeight.push($(this).height()+`px`)
      });
      
        const children = data.filter((doc) => doc.masterDocId === docId);
        if (children.length > 0) {
          let childRowsHtml = "";
          children.forEach((child) => {

            let status = child.status.StatusCode;
            // Check if data.StatusCode is undefined or null before calling toLowerCase
            if (status !== undefined && status !== null) {
              status = status.toLowerCase();
            } else {
              // Handle undefined or null case if needed
              status = 'unknown'; // Or any default value
            }
            let status_text = ''
            if (status === "success") {
              status_text = `<span className="badge bg-success">Success</span>`;
            } else if (status === "error") {
              status_text = `<span className="badge bg-danger">Failed</span>`;
            } else {
              status_text = `<span className="badge bg-warning">Running</span>`;
            }


            childRowsHtml += `
              <tr class="child-row">
                <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:`+arrWidth[0]+`;height:`+arrHeight[0]+`!important">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="javascript:void(0);"  class="view-btn" data-id="${child._id}" data-name="${child.FilePath}" data-status="${child.status.StatusCode}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>
                    ${getFilenameFromURL(child.FilePath)}
                  </a>
                </td>
                <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:`+arrWidth[1]+`;height:`+arrHeight[1]+`!important">${status_text}</td>
                <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:`+arrWidth[2]+`;height:`+arrHeight[2]+`!important">&nbsp;&nbsp;&nbsp;${child.documentType}</td>
                <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:`+arrWidth[3]+`;height:`+arrHeight[3]+`!important">&nbsp;&nbsp;&nbsp;${child.importdate}</td>
                <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:`+arrWidth[4]+`;height:`+arrHeight[4]+`!important">&nbsp;&nbsp;&nbsp;&nbsp;${child.importedby}</td>
                <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:`+arrWidth[5]+`;height:`+arrHeight[5]+`!important"><span class="react-buttons" data-id="${child._id}"></span></td>
              </tr>
            `;
          });

           //row.child(childRowsHtml).show();
            row.child(`<table class="child-table" style="table-layout: fixed;border-collapse: collapse;width:100%;border:none !important;">${childRowsHtml}</table>`).show();

          $(this).html(`
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>
          `);

          // Mount React Components for Child Rows
          setTimeout(() => {
            $(".react-buttons").each(function () {
              const childRoot = document.createElement("div");
              this.appendChild(childRoot);

              const reactChildRoot = ReactDOM.createRoot(childRoot);
              const childId = $(this).attr("data-id");
              const childData = data.find((doc) => doc._id === childId);

              if (childData) {
                reactChildRoot.render(<ActionButtons rowData={childData} />);
              }
            });
          }, 0);

          //          tablecontract_grid_expand.columns.adjust().draw(); // Adjust column widths after expanding
          
        }
      }
    });

    $("#contract_grid_expand tbody").on("click", ".toggle-btn", function () {
      const tr = $(this).closest("tr");
      const row = tablecontract_grid_expand.row(tr);
      const docId = $(this).attr("data-id");
  
      // Close any previously opened row
      $("#contract_grid_expand tbody .toggle-btn").not(this).each(function () {
          const otherTr = $(this).closest("tr");
          const otherRow = tablecontract_grid_expand.row(otherTr);
  
          if (otherRow.child.isShown()) {
              otherRow.child.hide();
              $(this).html(`
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
              `);
              otherTr.nextUntil(":not(.child-row)").remove(); // Remove child rows
          }
      });
  
      if (row.child.isShown()) {
          // If the clicked row is already open, close it
          row.child.hide();
          $(this).html(`
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
          `);
          tr.nextUntil(":not(.child-row)").remove();
      } else {
          let arrWidth = [];
          let arrHeight = [];
  
          $("#contract_grid_expand tbody tr:nth-child(1) td").each(function (index) {
              arrWidth.push($(this).width() + `px`);
              arrHeight.push($(this).height() + `px`);
          });
  
          const children = data.filter((doc) => doc.masterDocId === docId);
          if (children.length > 0) {
              let childRowsHtml = "";
              children.forEach((child) => {
                  let status = child.status.StatusCode ? child.status.StatusCode.toLowerCase() : 'unknown';
                  let status_text = status === "success"
                      ? `<span class="badge1 bg-success1">Success</span>`
                      : status === "error"
                      ? `<span class="badge1 bg-danger1">Failed</span>`
                      : `<span class="badge1 bg-warning1">Running</span>`;
  
                  childRowsHtml += `
                    <tr class="child-row">
                      <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:${arrWidth[0]};height:${arrHeight[0]}!important">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a href="javascript:void(0);" class="view-btn" data-id="${child._id}" data-name="${child.FilePath}" data-status="${child.status.StatusCode}">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>
                          ${getFilenameFromURL(child.FilePath)}
                        </a>
                      </td>
                      <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:${arrWidth[1]};height:${arrHeight[1]}!important">${status_text}</td>
                      <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:${arrWidth[2]};height:${arrHeight[2]}!important">&nbsp;&nbsp;&nbsp;${child.documentType}</td>
                      <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:${arrWidth[3]};height:${arrHeight[3]}!important">&nbsp;&nbsp;&nbsp;${child.importdate}</td>
                      <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:${arrWidth[4]};height:${arrHeight[4]}!important">&nbsp;&nbsp;&nbsp;&nbsp;${child.importedby}</td>
                      <td style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;border-collapse: collapse;width:${arrWidth[5]};height:${arrHeight[5]}!important">
                        <span class="react-buttons" data-id="${child._id}"></span>
                      </td>
                    </tr>
                  `;
              });
  
              row.child(`<table class="child-table" style="table-layout: fixed;border-collapse: collapse;width:100%;border:none !important;">${childRowsHtml}</table>`).show();
  
              $(this).html(`
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>
              `);
  
              // Mount React Components for Child Rows
              setTimeout(() => {
                  $(".react-buttons").each(function () {
                      const childRoot = document.createElement("div");
                      this.appendChild(childRoot);
  
                      const reactChildRoot = ReactDOM.createRoot(childRoot);
                      const childId = $(this).attr("data-id");
                      const childData = data.find((doc) => doc._id === childId);
  
                      if (childData) {
                          reactChildRoot.render(<ActionButtons rowData={childData} />);
                      }
                  });
              }, 0);
          }
      }
  });
  

    // React Component for Action Buttons
const ActionButtons = ({ rowData }) => {
  return (
    <>&nbsp;&nbsp;&nbsp;
      <OverlayTrigger
        placement="top"
        trigger={["hover", "click"]}
        overlay={<Tooltip id="view-top">View</Tooltip>}
      >
        <a
          href="javascript:void(0);"
          className="view-btn"
          data-id={rowData._id}
          data-name={rowData.FilePath}
          data-status={rowData.status?.StatusCode}
        >
          <i className="datatable-edit-icon"></i>
        </a>
      </OverlayTrigger>
      &nbsp;
      <OverlayTrigger
        placement="top"
        trigger={["hover", "click"]}
        overlay={<Tooltip id="delete-top">Delete</Tooltip>}
      >
        <a
          href="javascript:void(0);"
          className="delete-btn"
          data-bs-toggle="modal"
          data-bs-target="#confirmationModal"
          data-id={rowData._id}
          data-name={rowData.FilePath}
        >
          <i className="datatable-delete-icon"></i>
        </a>
      </OverlayTrigger>
      &nbsp;
      <OverlayTrigger
        placement="top"
        trigger={["hover", "click"]}
        overlay={<Tooltip id="askgenie-top">Ask Genie</Tooltip>}
      >
        <a
          href="javascript:void(0);"
          className="askgenie-btn"
          data-id={rowData._id}
          data-name={rowData.FilePath}
          data-status={rowData.status?.StatusCode}
        >
          <i className="datatable-askgenie-icon"></i>
        </a>
      </OverlayTrigger>
    </>
  );
};

//tablecontract_grid_expand.columns.adjust().draw(); // Adjust column widths after expanding

          return () => {
            tablecontract_grid_expand.destroy();
          };
          
        }, 10); // 3 seconds delay

      } 
    }
  }, [filteredData,activeTab]);



    // Search handler
    const handleSearch = (e) => {
      setSearchQuery(e.target.value);
      applyFilters(e.target.value, filters);
    };
  const [files, setFiles] = useState([]);

  // const handleDrop = (event) => {
  //   event.preventDefault();
  //   const droppedFiles = Array.from(event.dataTransfer.files);
  //   if (droppedFiles[0]?.size > 20 * 1024 * 1024) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       documentFile: "File size must not exceed 20 MB.",
  //     }));
  //     return;
  //   }
  //   setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  //   setFormData((prev) => ({ ...prev, documentFile: droppedFiles[0] }));
  //   setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
  // };

  // const handleFileSelect = (event) => {
  //   const selectedFiles = Array.from(event.target.files);
  //   const file = selectedFiles[0];
  //   if (file?.size > 20 * 1024 * 1024) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       documentFile: "File size must not exceed 20 MB.",
  //     }));
  //     return;
  //   }
  //   setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  //   setFormData((prev) => ({ ...prev, documentFile: file }));
  //   setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
  // };

  // const handleDragOver = (event) => {
  //   event.preventDefault();
  // };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  //   setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  // };

  // const handleDeleteFile = (index) => {
  //   setFiles(files.filter((_, i) => i !== index));
  // };

  // const simulateUpload = (files) => {
  //   files.forEach((file, index) => {
  //     setUploadProgress((prev) => ({ ...prev, [file.name]: 0 }));
  //     let progress = 0;
  //     const interval = setInterval(() => {
  //       progress += Math.random() * 20;
  //       if (progress >= 100) {
  //         clearInterval(interval);
  //         progress = 100;
  //       }
  //       setUploadProgress((prev) => ({ ...prev, [file.name]: progress }));
  //     }, 500);
  //   });
  // };

  // const handleSelectChange = (selectedOption, actionMeta) => {
  //   const { name } = actionMeta;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: selectedOption,
  //   }));
  //   setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  // };

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formData.taxonomy) newErrors.taxonomy = "Taxonomy is required.";
  //   if (!formData.documentType)
  //     newErrors.documentType = "Document Type is required.";
  //   // if (!formData.masterFile) newErrors.masterFile = "Master File is required.";
  //   if (!formData.documentType)
  //     newErrors.documentType = "Document Type is required.";
  //   if (
  //     formData.documentType === "Amendment" &&
  //     !formData.masterFile
  //   ) {
  //     newErrors.masterFile = "Master File is required for Master.";
  //   }

  //   if (!formData.documentFile) newErrors.documentFile = "Document File is required.";
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };


  // useEffect(() => {
  //   if (!isUploading && uploadQueue.length > 0) {
  //     uploadFile(uploadQueue[0]);
  //   }
  // }, [uploadQueue, isUploading]);

  // const handleUpload = () => {
  //   if (uploadQueue.length > 0 && !isUploading) {
  //     uploadFile(uploadQueue[0]);
  //   }
  // }


    // // Drag & Drop Handlers
    // const handleDrop = (event) => {
    //   event.preventDefault();
    //   const droppedFiles = Array.from(event.dataTransfer.files);
    //   handleFileSelection(droppedFiles);
    // };
  
    // const handleFileSelect = (event) => {
    //   const selectedFiles = Array.from(event.target.files);
    //   handleFileSelection(selectedFiles);
    // };
  
    // const handleFileSelection = (selectedFiles) => {
    //   if (selectedFiles.length === 0) return;
  
    //   const validFiles = selectedFiles.filter((file) => {
    //     if (file.size > 20 * 1024 * 1024) {
    //       setErrors((prev) => ({ ...prev, documentFile: "File size must not exceed 20 MB." }));
    //       return false;
    //     }
    //     return true;
    //   });
  
    //   if (validFiles.length > 0) {
    //     setFiles((prev) => [...prev, ...validFiles]);
    //     setFormData((prev) => ({ ...prev, documentFile: validFiles[0] }));
    //     setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
    //     setUploadQueue((prevQueue) => [...prevQueue, ...validFiles]);
    //   }
    // };
  
    // const handleDeleteFile = (index) => {
    //   setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    // };
  
    // const handleSelectChange = (selectedOption, actionMeta) => {
    //   setFormData((prev) => ({ ...prev, [actionMeta.name]: selectedOption }));
    //   setErrors((prevErrors) => ({ ...prevErrors, [actionMeta.name]: "" }));
    // };
  
    // const validateForm = () => {
    //   const newErrors = {};
  
    //   if (!formData.taxonomy) newErrors.taxonomy = "Taxonomy is required.";
    //   if (!formData.documentType) newErrors.documentType = "Document Type is required.";
    //   if (formData.documentType?.value === "Amendment" && !formData.masterFile) {
    //     newErrors.masterFile = "Master File is required for Amendments.";
    //   }
    //   if (!formData.documentFile) newErrors.documentFile = "Document File is required.";
  
    //   setErrors(newErrors);
    //   return Object.keys(newErrors).length === 0;
    // };
  
    
    // useEffect(() => {
    //   if (!isUploading && uploadQueue.length > 0) {
    //     uploadFile(uploadQueue[0]);
    //   }
    // }, [uploadQueue, isUploading]);
  


 const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    processFiles(droppedFiles);
  };

  const handleFileSelect = (event) => {
    const selectedFiles = Array.from(event.target.files);
    processFiles(selectedFiles);
  };

  const processFiles = (selectedFiles) => {
    const validFiles = selectedFiles.filter((file) => {
      if (file.size > 20 * 1024 * 1024) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          documentFile: "File size must not exceed 20 MB.",
        }));
        return false;
      }
      return true;
    });

    setFiles((prevFiles) => [...prevFiles, ...validFiles]);
    //setUploadQueue((prevQueue) => [...prevQueue, ...validFiles]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setUploadQueue((prevQueue) => prevQueue.filter((_, i) => i !== index));
  };

  const handleSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    setFormData((prev) => ({ ...prev, [name]: selectedOption }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.taxonomy) newErrors.taxonomy = "Taxonomy is required.";
    if (!formData.documentType) newErrors.documentType = "Document Type is required.";
    if (formData.documentType?.value === "Amendment" && !formData.masterFile) {
      newErrors.masterFile = "Master File is required for Amendment.";
    }
    if (files.length === 0) newErrors.documentFile = "At least one document file is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  


  // const handleUpload = () => {
  //   alert(1111);

  //   if (!validateForm()) return;
  //   if (uploadQueue.length > 0 && !isUploading) {

  //     alert(1111);

  //     //uploadFile(uploadQueue[0]);
  //   }
  // };


  // const saveDocument = (formData, onProgress) => {
  //   return new Promise((resolve) => {
  //     let progress = 0;
  //     const interval = setInterval(() => {
  //       progress += 10;
  //       if (typeof onProgress === "function") {
  //         onProgress(progress); // Ensure it's a function before calling
  //       }
  //       if (progress >= 100) {
  //         clearInterval(interval);
  //         resolve();
  //       }
  //     }, 200);
  //   });
  // };


  /*
  const saveDocument = async (data) => {

    $("#uploaderror").html(""); // Clear previous error
    let authToken = localStorage.getItem("jsondata");
    if (authToken) {
      const jsonData = JSON.parse(authToken);
      authToken = jsonData.accessToken || "";
    }
    $("#process-loader").removeClass("d-none"); // Show loader
    try {
      const response = await axios.post(API_SERVER_URL + "contracts/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + authToken,
        },
      });
      if (response.data.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
        handleClose();
        const targetElement = document.getElementById("app_err");
        if (targetElement) {
          ReactDOM.unmountComponentAtNode(targetElement);
        }
        ReactDOM.render(<Message type='success' message={response.data.data.message} />, targetElement);
        fetchData();
      } else {
        console.log("API Error Data:", response.data); // Debugging API response
        $("#process-loader").addClass("d-none");
        if (
          response.data.data &&
          response.data.data.error &&
          response.data.data.error.message
        ) {
          $("#uploaderror").html(response.data.data.error.message);
        } else {
          $("#uploaderror").html("An unexpected error occurred.");
        }
      }
    } catch (error) {
      console.error("Error uploading the file:", error);
      $("#process-loader").addClass("d-none");
      $("#uploaderror").html(
        `<div class="alert alert-danger" role="alert">
  `+ error.response?.data?.error.message || "An unexpected error occurred."+`
</div>`
      );
    }
  };
  */


  useEffect(() => {
    if (!isUploading && uploadQueue.length > 0) {
      uploadFile(uploadQueue[0]);
    }
  }, [uploadQueue, isUploading]);

  const saveDocument = async (data, file) => {
    $("#uploaderror").html(""); // Clear previous error
    let authToken = localStorage.getItem("jsondata");
    if (authToken) {
      const jsonData = JSON.parse(authToken);
      authToken = jsonData.accessToken || "";
    }
    $("#process-loader").removeClass("d-none"); // Show loader
    
    try {
      const response = await axios.post(API_SERVER_URL + "contracts/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + authToken,
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress((prev) => ({ ...prev, [file.name]: progress }));
        },
      });

      // if (response.data.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
      //   handleClose();
      //   const targetElement = document.getElementById("app_err");
      //   if (targetElement) {
      //     ReactDOM.unmountComponentAtNode(targetElement);
      //   }
      //   ReactDOM.render(<Message type='success' message={response.data.data.message} />, targetElement);
      //   fetchData();
      // } else {
      //   console.log("API Error Data:", response.data);
      //   $("#process-loader").addClass("d-none");
      //   $("#uploaderror").html(response.data.data?.error?.message || "An unexpected error occurred.");
      // }

    } catch (error) {
      console.error("Error uploading the file:", error);
      $("#process-loader").addClass("d-none");
      $("#uploaderror").html(
        `<div class="alert alert-danger" role="alert">
          ${error.response?.data?.error?.message || "An unexpected error occurred."}
        </div>`
      );
    }
  };
  
  const resetForm = (e) => {
    masterDocumentLoad()
    setFiles([])
    setFormData(initialState); // Reset form fields to initial state
    handleShow()
  }


  const masterDocumentLoad = async () => {
    try {
      let apiMasterDocumentUrl = API_SERVER_URL+ 'documents/master/'
      let methodMasterDocument = "GET"
      let resultMasterDocuemnts = await apiCall(methodMasterDocument,apiMasterDocumentUrl);
      if(resultMasterDocuemnts!==undefined){
      if (resultMasterDocuemnts.code === API_SUCCESS_RESPONSE_CODE) {
        setMasterDocumentOptions([
          // { value: "", label: "Select a Taxonomy" }, // Add an empty option
          ...resultMasterDocuemnts.data.map((item, i) => ({
            value: item._id,
            label: getFilenameFromURL(item.FilePath),
          })),
        ]);
      } else {
         trackError("The API response is invalid:<br/>URL:"+apiMasterDocumentUrl+"<br/>Method:"+methodMasterDocument+"<br>", JSON.stringify(resultMasterDocuemnts))
      }
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }

  }


  const uploadFile = ({ file, formDataapi }) => {
    setIsUploading(true);
  
    saveDocument(formDataapi, file).then(() => {
      setUploadQueue((prevQueue) => prevQueue.slice(1));
      setIsUploading(false);
  
      // If there are remaining files, process the next one
      if (uploadQueue.length > 1) {
        uploadFile(uploadQueue[1]);
      }
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const logged_user_name = getUsername();
  
    if (!validateForm()) return;
  
    $(".page_pro_load").show();
  
    const timestamp = Date.now();
    const randomDigits = Math.floor(Math.random() * 1000);
  
    // Iterate through each file and add to upload queue
    const newUploadQueue = files.map((file) => {
      const uniqueId = `doc_${parseInt(`${timestamp}${randomDigits}`.substr(0, 12))}`;
      
      const formDataapi = new FormData();
      formDataapi.append("file", file);
      formDataapi.append("doc_id", uniqueId);
      formDataapi.append("taxonomyId", formData.taxonomy.value);
      formDataapi.append("documentType", formData.documentType.value);
  
      if (formData.documentType.value === "Amendment") {
        formDataapi.append("masterDocId", formData.masterFile.value);
        formDataapi.append("masterDocFileName", formData.masterFile.label);
      } else {
        formDataapi.append("masterDocId", "");
        formDataapi.append("masterDocFileName", "");
      }
      
      formDataapi.append("username", logged_user_name);
  
      return { file, formDataapi };
    });
  
    setUploadQueue((prevQueue) => [...prevQueue, ...newUploadQueue]);
  
    if (!isUploading) {
      uploadFile(newUploadQueue[0]);
    }
  };

  
  

  const handleFilterChange = (filterName, value) => {
    setFilters((prevState) => {
      const newFilters = { ...prevState, [filterName]: value };
      applyFilters(newFilters);
      return newFilters;
    });
    setActiveTab('List View')
  };

  const applyFilters = (newFilters) => {
    let filteredDataTemp = data;


      // Multi-select filter for Document Type
  if (newFilters.filterdocumentType && newFilters.filterdocumentType.length > 0) {
    const selectedDocumentTypes = newFilters.filterdocumentType.map(option => option.value);
    filteredDataTemp = filteredDataTemp.filter((doc) =>
      selectedDocumentTypes.some(type => doc.documentType.includes(type))
    );
  }

  

  // Multi-select filter for Taxonomy
  if (newFilters.filtertaxonomy && newFilters.filtertaxonomy.length > 0) {
    const selectedTaxonomys = newFilters.filtertaxonomy.map(option => option.value);
    filteredDataTemp = filteredDataTemp.filter((doc) =>
      selectedTaxonomys.some(taxonomy => doc.taxonomyId.includes(taxonomy))
    );
  }

  // Multi-select filter for Status
  if (newFilters.filterstatus && newFilters.filterstatus.length > 0) {
    const selectedStatuses = newFilters.filterstatus.map(option => option.value.toLowerCase());
    filteredDataTemp = filteredDataTemp.filter((doc) =>
      selectedStatuses.some(status => doc.status.StatusCode.toLowerCase().includes(status))
    );
  }

  


    if (newFilters.filterTextSearch) { // New filter for text search
      filteredDataTemp = filteredDataTemp.filter((doc) => 
        doc.taxonomyId.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.status.StatusCode.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
      //  doc.taxonomy.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.importedby.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.importdate.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.documentType.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.FilePath.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc._id.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase())
      // )
      );
    }

    setFilteredData(filteredDataTemp);
  };

  const resetFilters = () => {
    setSearchQuery('');
    setFilters({
      filterdocumentType: null,
      filtertaxonomy: null,
      filterexpiryDate: '',
      filterstatus: null
    });
    setFilteredData(data); // Reset to full data
  };


  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
          <>
          <div className="flex-grow-1" id="row_heading">
            <div className="page-title">Contract List</div>
            <p className="text-muted my-2 ff-secondary">
             Manage and view all your contract documents
            </p>
            <div id="app_err"></div>
          </div>
          <div style={{ width: "30%" }}
          >
          <div className="card">
          <div className="card-body" style={{padding:"5px"}}>
          <ul className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1" role="tablist">
                <li className="nav-item">
                   <a             className={`nav-link fs-14 ${activeTab === 'List View' ? 'active' : ''}`} 
            data-bs-toggle="tab" 
            href="javascript:void(0)" 
            role="tab"
            onClick={() => handleTabChange('List View')}
>
                   <i className="ri-airplay-fill d-inline-block d-md-none"></i> <span className="d-none d-md-inline-block"><CommonIcon iconName="FileText" size={"17px"} color={activeTab === 'List View' ? '#fff' : '#000'}  /> List View</span>
                   </a>
                </li>
                <li className="nav-item">
                   <a className={`nav-link fs-14 ${activeTab === 'Folder View' ? 'active' : ''}`} 
            data-bs-toggle="tab" 
            href="javascript:void(0)" 
            role="tab"
            onClick={() => handleTabChange('Folder View')}
>
                   <i className="ri-list-unordered d-inline-block d-md-none"></i> <span className="d-none d-md-inline-block"><CommonIcon iconName="FolderOpen" size={"17px"} color={activeTab === 'Folder View' ? '#fff' : '#000'}  /> Hierarchical View</span>
                   </a>
                </li>
             </ul>
          </div>
          </div>
          </div>
          </>

          {data.length > 0 ? 
           <>
          <div className="row g-2 mb-4 mt-4" id="row_search">
            <div className="col-sm-10">
              <div className="search-box">
                <input
                  type="text"
                  className="form-control"
                  id="searchDocuments"
                  placeholder="Search Documents..."  // This should work as expected
                  onChange={(e) => handleFilterChange('filterTextSearch', e.target.value)}
                />
                <i className="grid-search">
                <CommonIcon iconName="Search" size={"14px"}  />
                </i>
              </div>
            </div>
            <div className="col-sm-auto ms-auto">
              <div className="list-grid-nav hstack gap-4">
                <button className="btn btn-light" onClick={fetchData}>
                <CommonIcon iconName="RefreshCw" size={"14px"} color={"#000"} />
                </button>
                <button onClick={resetForm}
                  className="btn btn-primary uploadcontract-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#addmemberModal"
                >
                  <CommonIcon iconName="Upload" size={"14px"} color="#fff" /> Upload
                </button>
                <button
                  type="button"
                  id="dropdownMenuLink1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className="d-none btn btn-soft-info btn-icon material-shadow-none fs-14"
                >
                  <i className="ri-more-2-fill"></i>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                  <li>
                    <a className="dropdown-item" href="#">
                      Show All
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Show Last Week
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Show Last Month
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Show Last Year
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row" id="row_filter" >
          <div className="col-lg-1 mt-2">
          <CommonIcon iconName="Filter" size={"14px"}  /> Filters:
          </div>
          <div className="col-lg-3">
          <Select
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option
                }}
                value={filters.filterdocumentType}
                onChange={(selectedOption) => handleFilterChange('filterdocumentType', selectedOption)}
                options={documentTypeOptions}
                placeholder="Document Type"
              />
          </div>
          <div className="col-lg-3">
          <Select
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option
                }}
                value={filters.filtertaxonomy}
                onChange={(selectedOption) => handleFilterChange('filtertaxonomy', selectedOption)}
                options={taxonomyOptions}
                placeholder="Taxonomy"
              />
          </div>
          {/* <div className="col-lg-2 mb-2">
          <input
                          type="date"
                          name="Expiry Date"
                          className="form-control"
                          placeholder="Expiry Date"
                          onChange={(e) => handleFilterChange('filterexpiryDate', e.target.value)}
                        />
          </div> */}
          <div className="col-lg-3 mb-2">
          <Select
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option
                }}
                value={filters.filterstatus}
                onChange={(selectedOption) => handleFilterChange('filterstatus', selectedOption)}
                options={statusoptions}
                placeholder="Status"
              />
              </div>
                {/* <div className="col-lg-1 mb-2">
              
                    <button className="btn btn-light" onClick={resetFilters}>
                    <CommonIcon iconName="FilterXIcon" size={"14px"} color={"#000"} />
                    </button>
              
          </div> */}
          </div>
        </> : "" }
      </div>
          <div className="row">
            <div className="col-lg-12">
              {/* <div className="card">
                <div className="card-body"> */}
                  <div>
                    {/* DataTable */}
                    {loading ? (
                 <PageLoader />
            ) :  data.length > 0 ?
                (
                <div className="row  mt-4">
                  <div className="col-lg-12">
                    
                    <div className={activeTab==="List View" ? "" :"d-none"}>
                   <table
                      id="contract_grid"
                      className="display"
                      style={{ width: "100%" }}
                    >
                      <thead>
                      </thead>
                    </table>
                    </div>
                    
                    <div className={activeTab==="Folder View" ? "" :"d-none"}>
                    <table
                      id="contract_grid_expand"
                      className="display"
                      style={{ width: "100%" }}
                    >
                      <thead>
                      </thead>
                    </table>
                    </div>
                  </div>
                </div>) : <div className="mt-5 card"><div className="text-center">
  <div className="no-doc-container my-4">
    {/* Bootstrap file-earmark icon with a warning sign */}
    <CommonIcon iconName="Database" width="50" height="50" />
    <div className="mt-3">
      <i className="bi bi-exclamation-circle-fill text-danger"></i>
    </div>
  </div>
  <h4 className="text-muted mb-4">No Contract Found</h4>
  <button onClick={resetForm}
              className="btn btn-primary uploadcontract-modal mb-4"
              data-bs-toggle="modal"
              data-bs-target="#addmemberModal"
            >
              <CommonIcon iconName="Upload" size={"14px"} color="#fff" /> Upload
            </button>
            <br/>
            <br/>
</div>
</div> }
                  </div>
                </div>
              </div>
            {/* </div>
          </div> */}
        </div>
      </div>

      <Modal show={deletedocumentmodal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title><div className="page-title" id="confirmationModalLabel">
                Delete
              </div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label class="form-label">Are you sure want to delete <span id="document_name"></span> document?</label>
          </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleDeleteClose} className="btn btn-light" data-bs-dismiss="modal"><CommonIcon iconName="X" size={"14px"} /> Close</button>
                  <button  disabled={isDeleting} onClick={handleDelete} id="btn_delete" data-id="1111" type="submit" className="btn btn-primary">
                    <CommonIcon iconName="Trash" size={"14px"} color="#fff" /> Delete
                  </button>
        </Modal.Footer>
      </Modal>



      <Modal show={adddocumentmodal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload New Contract</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-lg-12">
              <label className="form-label">Taxonomy</label>
              <Select
                name="taxonomy"
                options={taxonomyOptions}
                value={formData.taxonomy}
                onChange={handleSelectChange}
                placeholder="Select a Taxonomy"
              />
              {errors.taxonomy && <div className="text-danger">{errors.taxonomy}</div>}
            </div>

            <div className="col-lg-12">
              <label className="form-label">Document Type</label>
              <Select
                name="documentType"
                options={documentTypeOptions}
                value={formData.documentType}
                onChange={handleSelectChange}
                placeholder="Document Type"
              />
              {errors.documentType && <div className="text-danger">{errors.documentType}</div>}
            </div>

            {formData.documentType?.value === "Amendment" && (
              <div className="col-lg-12">
                <label className="form-label">Master File</label>
                <Select
                  name="masterFile"
                  options={masterDocumentOptions}
                  value={formData.masterFile}
                  onChange={handleSelectChange}
                  placeholder="Select Master File"
                />
                {errors.masterFile && <div className="text-danger">{errors.masterFile}</div>}
              </div>
            )}

            <div className="col-lg-12">
              <label className="form-label">Document File</label>
              <div className="dropzone" onDrop={handleDrop} onDragOver={(e) => e.preventDefault()} style={{ border: "2px dashed #ddd", padding: "20px", textAlign: "center" }}>
                <input type="file" id="fileInput" style={{ display: "none" }} onChange={handleFileSelect} accept="application/pdf" multiple />
                <label htmlFor="fileInput" style={{ cursor: "pointer" }}>Drop files here or click to upload</label>
              </div>
              <br/>
              {/* <ul>
                {files.map((file, index) => (
                  <li key={index} className="d-flex justify-content-between align-items-center">
                    {file.name} <CircularProgressbar 
                    styles={{
                      root: { width: 50, height: 50 },  // Adjust size
                      path: { stroke: "#007bff" },      // Progress color
                      text: { fontSize: "24px", fill: "#000" } // Text size & color
                    }}
                    value={uploadProgress[file.name] || 0} text={`${Math.round(uploadProgress[file.name] || 0)}%`} />
                    <button type="button" className="btn btn-primary btn-sm ms-2" onClick={() => handleDeleteFile(index)}>✖</button>
                  </li>
                ))}
              </ul> */}

<ul
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginLeft: "-35px",
    wordBreak: "break-word",
    maxHeight: "150px",
    overflowY: "auto",
  }}
>
  {files.map((file, index) => (
    <li
      key={index}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "#f8f9fa",
        padding: "8px 12px",
        borderRadius: "8px",
        width: "100%",
      }}
    >
      <span
        style={{
          flex: 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {file.name}
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <div style={{ width: "45px", height: "45px" }}>
          <CircularProgressbar
            value={uploadProgress[file.name] || 0}
            text={`${Math.round(uploadProgress[file.name] || 0)}%`}
            styles={{
              root: { width: "40px", height: "40px" },
              path: { stroke: "#007bff" },
              text: { fontSize: "25px", fill: "#000" },
            }}
          />
        </div>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={() => handleDeleteFile(index)}
        >
          ✖
        </button>
      </div>
    </li>
  ))}
</ul>


            </div>
          

{/* 
            <div className="col-lg-12">
              <label className="form-label">Document File</label>
              <div
                className="dropzone"
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                style={{ border: "2px dashed #ddd", padding: "20px", textAlign: "center" }}
              >
                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  onChange={handleFileSelect}
                  accept="application/pdf"
                  multiple
                />
                <div className="mb-3">
                  <CommonIcon iconName="Upload" size={"34px"} />
                </div>
                <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                  Drop files here or click to upload
                </label>
              </div>
              <ul style={{ marginTop: "20px", wordBreak: "break-word", maxHeight: "150px", overflowY: "auto" }}>
                {files.map((file, index) => (
                  <li key={index} className="d-flex justify-content-between align-items-center">
                    <span style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{file.name}</span>
                    <div style={{ width: 40, height: 40, marginLeft: 10 }}>
                      <CircularProgressbar value={uploadProgress[file.name] || 0} text={`${Math.round(uploadProgress[file.name] || 0)}%`} />
                    </div>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm ms-2"
                      onClick={() => handleDeleteFile(index)}
                    >
                      ✖
                    </button>
                  </li>
                ))}
              </ul>
              {errors.documentFile && <div className="text-danger">{errors.documentFile}</div>}
            </div> */}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={handleClose} className="btn btn-light" data-bs-dismiss="modal">
          <i className="ri-close-line align-bottom me-1"></i> Close
        </button>
        <button onClick={handleSubmit} type="submit" className="btn btn-primary">
          Save
        </button>
      </Modal.Footer>
    </Modal>


{/*
      <Modal show={adddocumentmodal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> 
                Upload New Contract
           </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-lg-12">
                    <label className="form-label">Taxonomy</label>
                    <Select
                        name="taxonomy"
                        options={taxonomyOptions}
                        value={formData.taxonomy}
                        onChange={handleSelectChange}
                        placeholder="Select a Taxonomy"
                      />
                    {errors.taxonomy && <div className="text-danger">{errors.taxonomy}</div>}
                  </div>
                 
                  <div className="col-lg-12">
                    <label className="form-label">Document Type</label>

                    <Select
            name="documentType"
            value={formData.documentType}
            onChange={handleSelectChange}
          options={documentTypeOptions}
          placeholder="Docuemnt Type"
        />
                   
                    {errors.documentType && <div className="text-danger">{errors.documentType}</div>}
                  </div>
                  { formData.documentType !== null && formData.documentType !== "" && formData.documentType.value === "Amendment" && (
                  <div className="col-lg-12">
                    <label className="form-label">Master File</label>

                      <Select
                        name="masterFile"
                        value={formData.masterFile}
                        onChange={handleSelectChange}
                        options={masterDocumentOptions}
                        placeholder="Select Master File"
                    />
                    {errors.masterFile && (
                      <div className="text-danger">{errors.masterFile}</div>
                    )}
                  </div>
                )}
                  <div className="col-lg-12">
                    <label className="form-label">Document File</label>
                    <div
                      className="dropzone"
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      style={{
                        border: "2px dashed #ddd",
                        padding: "20px",
                        textAlign: "center",
                      }}
                    >
                      <input
                        type="file"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={handleFileSelect}
                        accept="application/pdf"
                      />
                      <div className="mb-3">
                        <i className="display-4 text-muted">
                        <CommonIcon iconName="Upload" size={"34px"} />
                        </i>
                      </div>
                      <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                        Drop files here or click to upload
                      </label>
                    </div>
                    <ul style={{ marginTop: "20px",wordBreak:"break-all" }}>
                    {files.map((file, index) => (
                    <span>{file.name}</span>
                    ))}
                  </ul>
                    {errors.documentFile && <div className="text-danger">{errors.documentFile}</div>}
                  </div>
                <div className="page_pro_load mb-2">{
                <ProcessLoader pmMessage={"PDF upload in progress, please wait..."}  />
                }</div>
                <div id="uploaderror"></div>
                </div>
                
              </form>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleClose} className="btn btn-light" data-bs-dismiss="modal"><i className="ri-close-line align-bottom me-1"></i> Close</button>
              <button onClick={handleSubmit} type="submit" className="btn btn-primary">
                    Save
               </button>
        </Modal.Footer>
      </Modal> */}

    </div>
  );
};